module.exports = __webpack_public_path__ + "img/tablet_black.cc30dcce.svg";